<template>
  <div
    class="item"
    :class="[{'disabled': diagnoseCodes.includes(itemData.diagnoseCode)},{'selected':itemData.selected}]"
    @click="selecItem"
  >
    <span>{{itemData.diagnoseName}}</span>
    <span class="icon-select">
      <img src="@/assets/icon_selected.png" />
    </span>
  </div>
</template>

<script>
import Lodash from 'lodash';

export default {
  props: {
    itemData: {
      type: Object,
      value: null,
    },
  },
  computed: {
    diagnoseCodes() {
      const diagnoseItem = Lodash.clone(this.$store.state.diagnoseItem);
      return diagnoseItem.slice(0, 5).map((item) => item.diagnoseCode);
    },
  },
  methods: {
    selecItem() {
      if (this.diagnoseCodes.includes(this.itemData.diagnoseCode)) return;
      const itemData = Lodash.clone(this.itemData);
      const diagnoseItem = Lodash.clone(this.$store.state.diagnoseItem);
      itemData.isActive = true;
      itemData.selected = true;
      diagnoseItem.forEach((item) => {
        item.isActive = false;
        item.keyName = `${item.diagnoseCode}_${item.diagnoseName}_${item.diagnoseVersion}`;
      });
      if (diagnoseItem.length >= 7) {
        diagnoseItem[diagnoseItem.length - 2] = itemData;
      } else {
        diagnoseItem.splice(diagnoseItem.length - 1, 0, itemData);
      }

      this.$store.commit('healthDiagnose', { ...itemData, });
      this.$store.commit('diagnoseItem', diagnoseItem);
      this.$router.go(-1);
    },
  },
};

</script>

<style lang='scss' scoped>
.item {
  height: 44px;
  margin-left: 15px;
  margin-right: 15px;
  border-bottom: 1px solid #eee;

  @include flex(center,flex-start);
  @include font(15px,1,#333);

  .icon-select {
    display: none;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.disabled {
  color: #666;
  pointer-events: none;
}

.selected {
  @include font(15px,1,#07C164);

  .icon-select {
    display: block;

    img {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
